import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Gamepad2, Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { authenticate } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        authenticate(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.user.name}!`);
        navigate("/games", { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/auth", { replace: true });
      }
    })();
  }, [location.hash, authenticate, navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A14] flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Gamepad2 className="w-10 h-10 text-[#00F0FF]" />
      <div className="flex items-center gap-3 text-[#00F0FF] font-arcade text-2xl tracking-widest">
        <Loader2 className="w-6 h-6 animate-spin" /> SIGNING YOU IN…
      </div>
    </div>
  );
}
